var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "activity-modal",
      "visible": _vm.visible,
      "hide-footer": "",
      "title": "Activity Log",
      "centered": ""
    },
    on: {
      "hide": function hide($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('div', {
    staticClass: "activity-content"
  }, [_vm.data.length > 0 ? [_vm._l(_vm.data, function (item) {
    return _c('div', {
      key: item.id,
      staticClass: "history-item"
    }, [_c('p', [_c('strong', [_vm._v(_vm._s(item.updated_by_name))]), _vm._v(" modified the split to "), _c('strong', [_vm._v(_vm._s(item.split.from) + " / " + _vm._s(item.split.to))])]), _c('div', {
      staticClass: "date-row"
    }, [_c('span', {
      staticClass: "date-icon"
    }, [_c('i', {
      staticClass: "fa fa-calendar me-2"
    })]), _c('span', [_vm._v(_vm._s(item.history_updated_at))])]), _c('label', {
      staticClass: "reason-label"
    }, [_vm._v("REASON")]), _c('div', {
      staticClass: "reason-box"
    }, [_vm._v(" " + _vm._s(item.reason) + " ")])]);
  }), _c('hr')] : [_c('div', {
    staticClass: "reason-box"
  }, [_vm._v("No activity found")])]], 2), _c('div', {
    staticClass: "d-flex justify-content-end mt-3"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v("Close")])], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }